import { render } from "./TagIcon.vue?vue&type=template&id=07708577&scoped=true"
import script from "./TagIcon.vue?vue&type=script&lang=js"
export * from "./TagIcon.vue?vue&type=script&lang=js"

import "./TagIcon.vue?vue&type=style&index=0&id=07708577&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07708577"]])

export default __exports__